import ExerciseOfTheDay from './ExercisesOfTheDay';

export default ExerciseOfTheDay;
